import React, { useEffect, useRef } from "react";
import { pieChart, registerTheme } from "tui-chart";
import "tui-chart/dist/tui-chart.css";

const theme = {
  title: { color: "#8791af" },
  legend: { label: { color: "#8791af" } },
};

registerTheme("myTheme", theme);

function PieChart({ series, title }) {
  const chartRef = useRef(null);

  useEffect(() => {
    const container = chartRef.current;
    if (!container) return;

    // 로그인 직후/데이터 로딩 전 빈 값으로 렌더링될 수 있어 방어 처리
    const safeSeries = Array.isArray(series)
      ? series
          .filter((item) => item && typeof item.name !== "undefined")
          .map((item) => ({
            name: String(item.name),
            data: Number(item.data) || 0,
          }))
      : [];

    if (safeSeries.length === 0) {
      container.innerHTML = "";
      return;
    }

    const data = { series: safeSeries };

    const options = {
      chart: { width: container.offsetWidth, height: 305, title },
      legend: { align: "right", visible: true },
      theme: "myTheme",
    };

    const chart = pieChart(container, data, options);

    const handleResize = () => {
      chart.resize({ width: container.offsetWidth, height: 305 });
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chart.destroy();
    };
  }, [series, title]);

  return <div ref={chartRef} style={{ width: "100%" }} />;
}

export default PieChart;
